import React, { useEffect, useState } from 'react';
import '../CSS/HomeHighlights.css';

const HomeHighlightsDM = () => {
  const [Spotlight, setSpotlight] = useState([]);

  function openAndLog(proxyUrl, reportName, reportType) {
    const userEmail = localStorage.getItem('user-email');

    // Check for tag=daily
    const isDaily = proxyUrl.includes('tag=daily');

    // Only log if userEmail exists OR this was a daily-tagged click

    window.open(proxyUrl, '_blank', 'noopener,noreferrer');
  }

  const addProxyUrls = (items, reportType = 'FeaturedInsights') =>
    items.map(item => {
      // ✅ add tag=daily param
      const proxyUrl = `/api/highlights/${reportType}/${encodeURIComponent(item.name)}.pdf?tag=daily`;
      return {
        ...item,
        proxyUrl,
        open: () => openAndLog(proxyUrl, item.name, reportType)
      };
    });

  useEffect(() => {
    fetch('/api/hello')
      .then((response) => response.json())
      .then((data) => {
        // ✅ Add proxy URLs and limit to first 15
        const featuredWithProxy = addProxyUrls(data.FeaturedInsights).slice(0, 15);
        setSpotlight(featuredWithProxy);
      })
      .catch((error) => {
        console.error('Error fetching reports data:', error);
      });
  }, []);

  return (
    <div className="home-highlights">
      <ul className="list-item-home">
        {Spotlight.map((item, index) => (
          <li key={index}>
            <a
              href={item.proxyUrl}
              target="_blank"
              rel="noopener noreferrer"
              onClick={(e) => {
                e.preventDefault();   // always use our opener
                item.open();          // calls openAndLog(...)
              }}
            >
              {item.name}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default HomeHighlightsDM;
